"use client";

import { useParams, useRouter } from "next/navigation";
import { useEffect } from "react";

import { StorageKey, useLocalStorage } from "@/hooks/use-local-storage";

export function ReferralRegistration() {
  const { setValue: setReferral } = useLocalStorage(StorageKey.Referral);
  const router = useRouter();
  const param = useParams();

  useEffect(() => {
    const referral = param.referral;
    if (typeof referral === "string") {
      setReferral(referral);
    }
    router.push("/achievement-system");
  }, [param, router, setReferral]);
  return null;
}
